<div>
  <div class="password-check"><mat-icon *ngIf="passwordLengthOk" color="accent">check_circle_outline</mat-icon><mat-icon
      *ngIf="!passwordLengthOk" color="warn">error_outline</mat-icon><span class="ml-1">Au moins 8
      caractères</span></div>
  <div class="password-check"><mat-icon *ngIf="passwordComplexityOk"
      color="accent">check_circle_outline</mat-icon><mat-icon *ngIf="!passwordComplexityOk"
      color="warn">error_outline</mat-icon><span class="ml-1">Au moins une majuscule, minuscule et chiffre</span></div>
</div>